'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import NewsForm from 'Components/Forms/Models/News/NewsForm';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
export default class UpdateNewsPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const is__super_admin = window.location.pathname.startsWith('/super-admin');
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Mise \xE0 jour d'une actualit\xE9"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement(Button, {
      component: Link,
      href: URL(is__super_admin ? 'SuperAdminNewsDashboard' : 'AdminNewsDashboard'),
      className: "u-margin-bottom-15"
    }, '<', " Retour aux actualit\xE9s"), /*#__PURE__*/React.createElement(NewsForm, {
      type: "update"
    })));
    return output;
  }
}
